import React from 'react'
import { cn } from '@/common/lib/cn/cn'

export type DrawerProps = {
    children: React.ReactNode
    className?: string
    menu?: React.ReactNode
    id?: string
}

export const Drawer = ({ children, className, menu, id }: DrawerProps) => {
    const DrawerClass = cn('', className)
    return (
        <div className={DrawerClass}>
            <input id={id} type='checkbox' className='drawer-toggle' />
            <div className=''>{children}</div>
            <div className='drawer-side z-100'>
                <label htmlFor={id} aria-label='close sidebar' className='drawer-overlay'></label>
                <div className='p-4 bg-base-100 h-full z-100'>{menu}</div>
            </div>
        </div>
    )
}
export type DrawerLabelProps = {
    children: React.ReactNode
    id: string
} & React.HTMLAttributes<HTMLLabelElement>

export const DrawerLabel = ({ children, id, ...props }: DrawerLabelProps) => {
    return (
        <label htmlFor={id} aria-label='close sidebar' {...props}>
            {children}
        </label>
    )
}
